import * as React from 'react';
import { cn } from '../../utils/cn';

export interface PillButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** Whether the button is in a selected state */
    selected?: boolean;
    /** Size variant of the button */
    size?: 'sm' | 'md';
}

/**
 * A pill-shaped toggle button for single or multi-select options.
 * Used for selecting options like project type, scope, etc.
 */
export const PillButton = React.forwardRef<HTMLButtonElement, PillButtonProps>(
    ({ className, selected = false, size = 'md', children, ...props }, ref) => {
        return (
            <button
                ref={ref}
                type="button"
                className={cn(
                    'rounded-full border text-base transition-colors disabled:pointer-events-none disabled:text-gray-400',
                    size === 'sm' && 'px-3 py-2',
                    size === 'md' && 'px-6 py-2.5',
                    selected
                        ? 'border-black bg-black text-white'
                        : 'border-gray-100 bg-gray-100 text-gray-900 hover:bg-gray-200',
                    className,
                )}
                {...props}
            >
                {children}
            </button>
        );
    },
);

PillButton.displayName = 'PillButton';
